import SignIn from "./pages/Signin/SignIn.tsx";
import WelcomeOnboard from "./pages/WelcomeOnboard/WelcomeOnboard.tsx";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home/Home.tsx";
import RouteDecider from "./containers/RouteDecider.tsx";
import Analytics from "./containers/Analytics.tsx";
import FreeTrialStripeWrapper from "./pages/FreeTrial/FreeTrialStripeWrapper.tsx";
import PaymentInfoProvider from "./providers/PaymentInfoProvider.tsx";
import SubscriptionProvider from "./providers/SusbscriptionProvider.tsx";
import AuthProvider from "./providers/AuthProvider.tsx";
import {
  ROUTE_FREE_TRIAL,
  ROUTE_SIGN_IN,
  ROUTE_SUBSCRIBE,
  ROUTE_WELCOME_ONBOARD,
} from "./lib/constants.ts";

function App() {
  return (
    <Router>
      <AuthProvider>
        <SubscriptionProvider>
          <PaymentInfoProvider>
            <RouteDecider />
            <Analytics />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path={ROUTE_SIGN_IN} element={<SignIn />} />
              <Route
                path={ROUTE_FREE_TRIAL}
                element={<FreeTrialStripeWrapper freeTrialActive={true} />}
              />
              <Route
                path={ROUTE_SUBSCRIBE}
                element={<FreeTrialStripeWrapper freeTrialActive={false} />}
              />
              <Route
                path={ROUTE_WELCOME_ONBOARD}
                element={<WelcomeOnboard />}
              />
            </Routes>
          </PaymentInfoProvider>
        </SubscriptionProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
